export default function makeUrlResolver(baseUrl: string, defaultBaseUrl=window.location.href): (pathname:string) => string {
    let url: URL
    try{ url = new URL(baseUrl); } catch { url = new URL(baseUrl, defaultBaseUrl); }
    const resolveUrl = (pathname: string): string  => new URL(pathname, url).href;
    return resolveUrl;
}
